import React, { Fragment, useEffect, useState } from "react";
import { Route, Routes, useLocation, useParams } from "react-router-dom";
import EventHome from "../Panel/Event/Components/Home";
import Announcements from "../Announcements/index";
import About from "./About/About";
import RegisterTeams from "./RegisterTeams/RegisterTeams";
import TopBar from "../Panel/Event/Components/Home/TopBar";
import { useDispatch, useSelector } from "react-redux";
import useVariables from "../../../common/hooks/useVariables";
import { EVENT, isLoading, setEVENT, load, unload } from "../../../Store/Features/EventSlice";
import { GetSingleEvent } from "../../../Config/API/events";
import Loader from "../../../common/cards/Loader";
import { GetPanelsOfOwner } from "../../../Config/API/panel";

const index = () => {
  const [isOrg, setisOrg] = useState(""); //event organizer
  const [panelFound, setPanelFound] = useState(false);
  const [teamFound, setTeamFound] = useState(false);
  const { id } = useParams();

  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const event = useSelector(EVENT);
  const loading = useSelector(isLoading);

  const { viewer } = useVariables();
  const get = async () => {
    try {
      dispatch(load());

      const res = await GetSingleEvent({ eventId: id });
      const res2 = await GetPanelsOfOwner(viewer?.id);

      const data = await res.json();
      const data2 = await res2.json();

      // Check if this announcement is posted by user
      const foundPanel = data2.result?.some(
        (panelEntry) => panelEntry._id === data?.result?.panel?._id
      );
      setPanelFound(foundPanel);

      // Check if the current user is a register Team member
      const foundTeam = data?.result?.registerteams.some((teamEntry) =>
        teamEntry?.team?.members.some((member) => member._id === id)
      );
      setTeamFound(foundTeam);

      if (data?.type === "success") {
        dispatch(setEVENT(data?.result));
        setisOrg(pathname.includes("organizer") && data?.result?.organizer?._id === viewer?.id);
      }
      dispatch(unload());
    } catch (e) {
      dispatch(unload());
    }
  };

  useEffect(() => {
    get();

    return () => {
      setisOrg(null);
    };
  }, []);

  return loading ? (
    <Loader fullpage loading={"white"} text={"Please Wait fetching Event details"} />
  ) : (
    <Fragment>
      <div className="profile-header">
        <div className="layout-width">
          <TopBar
            data={event}
            eventId={id}
            isOrg={isOrg}
            panelFound={panelFound}
            teamFound={teamFound}
          />
        </div>
      </div>
      <div className="layout-width">
        <Routes>
          <Route path="/" element={<EventHome event={event} eventId={id} isOrg={isOrg} />} />
          <Route
            path="/timeline"
            element={<EventHome event={event} eventId={id} isOrg={isOrg} />}
          />
          <Route
            path="/announcements"
            element={<Announcements event={event} panelFound={panelFound} teamFound={teamFound} />}
          />
          <Route path="/about" element={<About event={event} />} />
          <Route path="/registerteams" element={<RegisterTeams event={event} />} />
          <Route
            path="*"
            element={
              <h1
                style={{
                  textAlign: "center",
                  margin: "90px 0",
                  fontSize: "xx-large"
                }}>
                Page Not Found
              </h1>
            }
          />
        </Routes>
      </div>
    </Fragment>
  );
};

export default index;
